//#region module
import cubejs from '@cubejs-client/core'
import { CubeProvider, QueryRenderer } from '@cubejs-client/react'
import React, { useCallback, useEffect, useContext, useMemo, useState } from 'react'
import ChartRenderer from '../components/ChartRenderer'
import { url } from '../config/urls'
import _ from 'lodash'
import { useComparisonChartDetails, useQuickFilter, ReportDetailsContextProvider, ComparisonChartDetailsContextProvider, QuickFilterContextProvider } from '../layouts/report/ReportDetailsContext'
import { removeReference } from '../utils/Reusables'
import { CubeContext } from "@cubejs-client/react";
import { mergeReportsDataMaster } from '../utils/MergeReport'
import { Box, Skeleton } from '@mui/material'


const API_URL = url.cubeApiUrl
const CUBE_PUBLISHED_URL = url.cubePublishedApiUrl

// keep the context here
export default function ReportGraph(props) {
  return (
    <ReportDetailsContextProvider reportDetails={props.reportDetails?.report} vizState={props.reportDetails?.vizState}>
      <ComparisonChartDetailsContextProvider>
        <QuickFilterContextProvider>
          <InermediateReportGraph {...props} />
        </QuickFilterContextProvider>
      </ComparisonChartDetailsContextProvider>
    </ReportDetailsContextProvider>
  )
}

function InermediateReportGraph({updateReport, reportDetails, getPivotColState, gridColumnApi, setGridColumnApi, openToolBar = true, h = null, reportIn = null, hasFilters = null, hasLinkedReports, tableColumnnsView, reportOfLinkedType = null }) {
  const { selectedMeasures, selectedDimension, comparisonChartType } = useComparisonChartDetails();
  const { quickFilterList } = useQuickFilter()
  const cubejsApi = useContext(CubeContext).cubejsApi
  const reportRef = React.useRef()
  const [currpage, setCurrPage] = useState(1)
  const [queryOrder, setQueryOrder] = useState(null)
  const [queryObj, setQueryObj] = useState(null)
  const [combinedResults, setCombinedResults] = useState(null);
  const [loading, setLoading] = useState(true)
  const [combinedResultLoading, setCombinedResultLoading] = useState(false)

  // React.useLayoutEffect(() => {
  //   setTimeout(() => {
  //     if (reportDetails?.vizState?.chartType === 'table') {
  //       let reportId = '#report' + reportDetails.name.replace(' ', '') + ' .ant-table-row';

  //       const reportEl = document.querySelector(reportId);
  //       if (reportEl) {
  //         let reportheaderId = '#report' + reportDetails.name.replace(' ', '') + ' thead';
  //         const reportElHead = document.querySelector(reportheaderId);
  //         let tableHeaderHeight = reportElHead.getBoundingClientRect().height;
  //         let tableRowHeight = reportEl.getBoundingClientRect().height;
  //         const tableReport = document.querySelector('#report' + reportDetails.name.replace(' ', '') + ' .ant-table-content');

  //         if (tableReport) {
  //           tableReport.style.height = tableHeaderHeight + tableRowHeight * 10 + 'px';
  //           tableReport.style.maxHeight = tableHeaderHeight + tableRowHeight * 10 + 'px';
  //           tableReport.style.overflow = 'auto';
  //         }


  //       }

  //     }
  //   }, 1000)

  // }, [reportRef])


  const handleVizState = useCallback((vizState) => {
    //console.log(vizState)
    const { query } = vizState
    let timeDimFormatObj = {}
    if (Array.isArray(query)) {
      query?.map(qry => {
        if (qry?.timeDimensions) {
          qry?.timeDimensions.map((obj, index) => {
            let { dateFormat, dimension, granularity } = obj
            timeDimFormatObj[index] = { key: dimension, format: dateFormat, granularity: granularity }
          })
        }
      })
    }
    else {
      if (query?.timeDimensions) {
        query?.timeDimensions?.map((obj, index) => {
          let { dateFormat, dimension, granularity } = obj
          timeDimFormatObj[index] = { key: dimension, format: dateFormat, granularity }
        })
      }
    }
    vizState.timeDimensionDateFormat = timeDimFormatObj
    if (vizState?.chartType == 'table' && (vizState?.pivotConfig?.group?.filter(obj => obj.type == 'dimensions').length > 0 || query?.dimensions?.filter(value => vizState?.pivotConfig?.y?.includes(value))?.length > 0)) {
      delete vizState.query.limit
      delete vizState.query.offset
    }
    return vizState
  })

  const timeDimensionMapper = useCallback((query) => {
    if (Array.isArray(query)) {
      query?.map(qry => {
        if (qry?.timeDimensions) {
          let updatedTimeDimensions = []
          qry?.timeDimensions.map(obj => {
            let { dimension, dateRange, granularity, dateRangeArray, compareDateRange } = obj
            dateRangeArray = dateRangeArray?.length ? dateRangeArray : undefined
            compareDateRange = compareDateRange?.length ? compareDateRange : undefined
            updatedTimeDimensions.push({
              dimension, dateRange: dateRange || dateRangeArray,
              granularity: granularity === "null" ? null : granularity,
              compareDateRange,
            })
          })
        }
      })
    } else {
      let updatedTimeDimensions = []
      if (query?.timeDimensions) {
        query?.timeDimensions?.map(obj => {
          let { dimension, dateRange, granularity, dateRangeArray, compareDateRange, dateFormat } = obj
          dateRangeArray = dateRangeArray?.length ? dateRangeArray : undefined
          compareDateRange = compareDateRange?.length ? compareDateRange : undefined
          updatedTimeDimensions.push({
            dimension, dateRange: dateRange || dateRangeArray,
            granularity: granularity === "null" ? null : granularity,
            compareDateRange,
          })
        })
        query.timeDimensions = updatedTimeDimensions
      }
    }
    //console.log(reportDetails?.vizState?.chartType,reportDetails?.vizState?.pivotConfig,reportDetails?.vizState?.pivotConfig?.group,)
    if (reportDetails?.vizState?.chartType == 'table' && (reportDetails?.vizState?.pivotConfig?.group?.filter(obj => obj.type == 'dimensions').length > 0 || query?.dimensions?.filter(value => reportDetails?.vizState?.pivotConfig?.y?.includes(value))?.length > 0)) {
      delete query.limit
      delete query.offset
    }

    if (Array.isArray(query)) {
      return query
    }
    return { ...query, renewQuery: true, total: true }
  })

  reportDetails.vizState = handleVizState(reportDetails?.vizState)


  //for comparision chart
  useEffect(() => {
    //console.log(reportDetails?.vizState?.query)
    if (!reportDetails || !comparisonChartType || !selectedDimension || !selectedMeasures) return null
    const { measures, dimensions } = reportDetails?.vizState?.query;
    const linesMes = reportDetails?.vizState?.pivotConfig?.lines?.filter(obj => obj.type == 'measures')?.map(line => line?.text);
    const linesDim = reportDetails?.vizState?.pivotConfig?.lines?.filter(obj => obj.type == 'dimensions')?.map(line => line?.text);
    const groupByMes = reportDetails?.vizState?.pivotConfig?.group?.filter(obj => obj.type == 'measures')?.map(group => group?.text);
    const groupByDim = reportDetails?.vizState?.pivotConfig?.group?.filter(obj => obj.type == 'dimensions')?.map(group => group?.text);
    const filterdMeasure = measures?.filter((_measure) => _measure === selectedMeasures?.fieldName);
    const filterdDimension = dimensions?.filter((_dimension) => _dimension === selectedDimension?.fieldName);
    setQueryObj(
      (prevState) => {
        if (prevState) {
          return { ...prevState, total: true, measures: [...filterdMeasure, ...linesMes, ...groupByMes], dimensions: [...filterdDimension, ...linesDim, ...groupByDim], filters: reportDetails?.vizState?.query?.filters }
        } else {
          return { ...reportDetails?.vizState?.query, total: true, measures: [...filterdMeasure, ...linesMes, ...groupByMes], dimensions: [...filterdDimension, ...linesDim, ...groupByDim] }
        }
      }
    )
  }, [selectedMeasures, selectedDimension, reportDetails?.vizState?.query, reportDetails?.vizState])

  useEffect(() => {
    if (!quickFilterList || quickFilterList.length < 1) return null
    const quickFilters = quickFilterList.reduce((qfArr, quickFilter) => {
      const { member, listType, conditions } = quickFilter;
      // on the basis of selected conditions we will create the query
      let appliedConditions = conditions.filter(obj => obj.selected)
      appliedConditions.forEach(condition => {
        const values = condition.values.map(obj => parseFloat(obj))
        if (condition.operator === 'bw') {
          let startObj = {
            member: member,
            operator: 'gte',
            values: [Math.min(...values)]
          }
          let endObj = {
            member: member,
            operator: 'lte',
            values: [Math.max(...values)]
          }
          qfArr = [...qfArr, startObj, endObj]
        } else {
          qfArr.push({ member, operator: condition.operator, values: condition.values })
        }
      })
      return qfArr
    }, []);
    //if (quickFilters.length < 1) return null
    setQueryObj({ ...reportDetails?.vizState?.query, filters: [...(reportDetails?.vizState?.query?.filters || []), ...quickFilters], total: true })
  }, [quickFilterList])

  useEffect(() => {
    if (reportDetails?.vizState?.chartType == 'table') {
      setQueryObj((prevState) => { return { ...prevState, offset: (currpage - 1) * prevState?.limit } })
    }
  }, [currpage])

  useEffect(() => {
    if(queryObj && reportDetails?.report?.mergeReport?.length > 0 && reportDetails?.vizState?.chartType == 'table'){
      mergeMaster()
    }else{
      setLoading(false)
    }
  }, [queryObj])

  const mergeMaster = async () => {
    setCombinedResultLoading(true)
    const result = await mergeReportsDataMaster(queryObj,reportDetails?.report?.mergeReport)
    setCombinedResults(result)
    setCombinedResultLoading(false)
    setLoading(false)
  }

  const updateReportOrderBy = (newQuery) => {
    setQueryObj((prevState) => { return { ...prevState, order: { ...newQuery.order } } })
  }

  useEffect(() => {
    //console.log(reportDetails)
    if (reportDetails?.vizState?.query && !comparisonChartType) {
      let queryObj = {}
      switch (reportDetails?.vizState?.chartType) {
        case 'table':
          queryObj = {
            ...reportDetails?.vizState?.query,
            offset: (currpage - 1) * reportDetails?.vizState?.query?.limit,
            renewQuery: false,
            total: true
          }
          break;
        default:
          queryObj = {
            ...reportDetails?.vizState?.query,
            total: true,
            renewQuery: false,
          }
          break;
      }
      setCurrPage(1)
      setQueryObj({ ...reportDetails?.vizState?.query, total: true })
    }
  }, [reportDetails?.vizState])

  return (
    <>
      {loading || combinedResultLoading ? (
        reportDetails?.vizState?.chartType === "number" ? (
          <Box className="width-100">
            <Skeleton className="progress-skeleton" animation="wave" />
            <Skeleton className="progress-skeleton half" animation="wave" />
          </Box>
        ) : (
          <Box className="width-100">
            <Skeleton className="progress-skeleton" animation="wave" />
            <Skeleton className="progress-skeleton half" animation="wave" />
            <Skeleton className="progress-skeleton quarter" animation="wave" />
          </Box>
        )
      ) : (
        <QueryRenderer
          query={timeDimensionMapper(queryObj ? removeReference(queryObj) : {})}
          render={(QueryRendererProps) => (
            <div id={`report${reportDetails?.name?.replace(" ", "")}`}>
              {reportDetails?.vizState ? (
                <ChartRenderer
                  updateReport={updateReport}
                  vizState={reportDetails?.vizState}
                  getPivotColState={getPivotColState}
                  gridColumnApi={gridColumnApi}
                  setGridColumnApi={setGridColumnApi}
                  openToolBar={openToolBar}
                  QueryRendererProps={QueryRendererProps}
                  h={h}
                  reportIn={reportIn}
                  hasFilters={hasFilters}
                  hasLinkedReports={hasLinkedReports}
                  setCurrPage={setCurrPage}
                  currpage={currpage}
                  updateReportOrderBy={updateReportOrderBy}
                  tableColumnnsView={tableColumnnsView}
                  reportOfLinkedType={reportOfLinkedType}
                  combinedResults={combinedResults}
                />
              ) : null}
            </div>
          )}
        />
      )}
    </>
  );
}